
import {apiUrl} from '../constants';
import axios from 'axios';
import { stringify } from 'querystring';
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':'Bearer ' + localStorage.getItem('token'),'Content-Type':'application/json'}
})

export default class DrivePromotionsAPI{

    /**
     * Obtienen todo el listado de promociones
     */
    static getAll(){
        return request.get('/Promotions/');
    }

    /**
     * Obtienen listado de promociones por parametros
     */
     static getByParams(params){
        return request.get(`/Promotions/params?${stringify({...params})}`);
    }

    /**
     * Crea una promoción.
     * @param { Object } data - Informacion de la promoción 
     * @returns Promise
     */
    static create( data ) {
        return request.post( '/Promotions/', data );
    }

    /**
     * Obtiene promocion por id
     * @param { Object } idPromo - Informacion de la promoción
     * @returns Promise
     */
    static get( id) {
        return request.get( `/Promotions/${id}` );
    }

    /**
     * Actualiza promocion id 
     * @param { Object } id - identificador de la promocion
     * @param { Object } newData - información actualizada
     * @returns Promise
     */
     static update( id, newData ) {
        return request.put( `/Promotions/${id}`,newData  );
    }

    /**
     * Cambia el estatus de una promoción 
     * @param {*} id identificador de la promoción 
     * @param {*} newStatus nuevo estatus 
     */
    static updateStatus(id, newStatus){
        return request.patch( `/Promotions/${id}/${newStatus}`);
    }
}